module.exports = __webpack_public_path__ + "static/img/map_shanxi2.cfbfbfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map_shanxi2.png
// module id = 8qhm
// module chunks = 0